import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 24px;

  background-color: ${(props) => props.theme.colors.greys.lighter};
`;

export const ContentContainer = styled.div`
  width: 100%;
  height: calc(100% - 96px);

  overflow-y: hidden;

  background: ${(props) => props.theme.colors.greys.lighter};
`;

export const ListContainer = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`;

export const SidePaddedGapContainer = styled.div`
  width: 100%;
  padding: 0 24px;
`;

export const FlexedGapContainer = styled.div`
  display: flex;
  column-gap: 24px;
`;

export default {
  Container,
  ContentContainer,
  SidePaddedGapContainer,
  FlexedGapContainer,
};
